// Prerender all pages at build time for instant loads
export const prerender = true;

// Client-side rendering for SPA navigation
export const csr = true;
